import { atom } from 'nanostores';

/** Controls visibility of the inline auth modal */
export const $showAuthModal = atom<boolean>(false);

/** Stores the message the user typed before being prompted to auth */
export const $pendingMessage = atom<string | null>(null);

/**
 * Raw image files attached to a new chat's first message. The composing
 * component unmounts on the new-chat route change, so the File[] is stashed here
 * (in memory — same JS runtime, no reload) and the freshly-mounted ChatImpl
 * uploads and sends them through the exact same path an existing chat uses.
 * Paired with $pendingMessage; both are consumed once on mount.
 */
export const $pendingFiles = atom<File[] | null>(null);

/**
 * Pages that are a handoff back to another app — the desktop sign-in and the
 * desktop Linear connect. Their whole job lives in the URL (`redirect_uri`,
 * `state`), so signing in must happen on top of them: navigating away (to `/`,
 * or `/welcome` for a new account) drops the query and strands the user on the
 * main chat with the desktop app still waiting.
 */
const STAY_ON_PAGE_PATHS = ['/desktop-auth', '/desktop-linear'];

export function isStayOnPagePath(pathname: string): boolean {
  return STAY_ON_PAGE_PATHS.includes(pathname.replace(/\/+$/, ''));
}
